module.exports = __webpack_public_path__ + "img/10.98e79cef.png";